import { RG_TYPE as t } from "@project-rouge/rg-core";
function s(e) {
  let l = 0;
  if (e.type === t.Building)
    e.children.forEach((i) => {
      l += s(i);
    });
  else if (e.type === t.Apartment)
    for (const i of e.children)
      i.type === t.Module ? l += s(i) : [t.Balcony].includes(i.type) && (l += i.size[0] * e.size[1] * i.size[2]);
  else
    l = e.size[0] * e.size[1] * e.size[2];
  return l;
}
export {
  s as getVolume
};
//# sourceMappingURL=index7.js.map
